// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactNavBar-cls1_axl","cls2":"ImpactNavBar-cls2_CGG ImpactNavBar-cls1_axl"};